import React from 'react'
import {
  Table as MuiTable,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableBody,
  Paper,
  Box
} from '@mui/material'
import Row from './Row'
import { LoadingSkeletonRows } from '../../shared/LoadingSkeletonRows'
import ErrorMessage from '../../../component/shared/component/ErrorMessage'

const Table = ({ data, isLoading, refetch }) => {
  return (
    <Box>
      {data.length || isLoading ? (
        <>
          <TableContainer component={Paper}>
            <MuiTable>
              <TableHead>
                <TableRow>
                  <TableCell>Name</TableCell>
                  <TableCell>Email</TableCell>
                  <TableCell>Total</TableCell>
                  <TableCell>View</TableCell>
                  <TableCell>Send</TableCell>
                  <TableCell>Status</TableCell>
                  <TableCell>Delete</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {isLoading ? (
                  <LoadingSkeletonRows rows={10} length={6} />
                ) : (
                  data.map((row) => <Row data={row} key={row._id} refetch={refetch} />)
                )}
              </TableBody>
            </MuiTable>
          </TableContainer>
        </>
      ) : (
        <ErrorMessage empty />
      )}
    </Box>
  )
}

export default Table
